<template>
  <div class="loginpage">
    <base-nav v-model="showMenu" :toggled="false" :show="showMenu" ref="baseNav" type="light" :transparent="true"
      menu-classes="justify-content-end" class="navbar-horizontal navbar-main" expand="lg" v-if="socialAddresses">
      <!-- <div slot="brand" class="navbar-wrapper">
        <b-navbar-brand>
          <img
            :src="`${(place_public_data.place.xfields.Logotipo.value || place_public_data.place.xfields.Logotipo.label).filepath}`"
          />
        </b-navbar-brand>
      </div> -->

      <template>
        <div class="navbar-collapse-header">
          <b-row>
            <b-col cols="6" class="collapse-brand">
              <img v-if="placeLogoUrl" :src="placeLogoUrl" />
            </b-col>
            <b-col cols="6" class="collapse-close">
              <button type="button" class="navbar-toggler" @click="closeMenu">
                <span></span>
                <span></span>
              </button>
            </b-col>
          </b-row>
        </div>

        <b-navbar-nav v-if="false" class="mr-auto">
          <b-nav-item to="/dashboard">
            <span class="nav-link-inner--text">Dashboard</span>
          </b-nav-item>
          <b-nav-item to="/pricing">
            <span class="nav-link-inner--text">Pricing</span>
          </b-nav-item>
          <b-nav-item to="/login">
            <span class="nav-link-inner--text">Login</span>
          </b-nav-item>
          <b-nav-item to="/register">
            <span class="nav-link-inner--text">Register</span>
          </b-nav-item>
          <b-nav-item to="/lock">
            <span class="nav-link-inner--text">Lock</span>
          </b-nav-item>
        </b-navbar-nav>
        <hr class="d-lg-none" v-if="false" />
       <!-- <b-navbar-nav v-if="socialAddresses" class="align-items-lg-center ml-lg-auto">
          <b-nav-item link-classes="nav-link-icon"
            v-if="place_public_data.place != undefined && place_public_data.place.xfields.Facebook != undefined && (place_public_data.place.xfields.Facebook.value || place_public_data.place.xfields.Facebook.label) != ''"
            :href="`${place_public_data.place.xfields.Facebook.value || place_public_data.place.xfields.Facebook.label}`" target="_blank" data-toggle="tooltip"
            data-original-title="Like us on Facebook">
            <i class="fab fa-facebook-square"></i>
            <span class="nav-link-inner--text d-lg-none">Facebook</span>
          </b-nav-item>
          <b-nav-item link-classes="nav-link-icon"
            v-if="place_public_data.place != undefined && place_public_data.place.xfields.Instagram != undefined && (place_public_data.place.xfields.Instagram.value || place_public_data.place.xfields.Instagram.label) != ''"
            :href="`${place_public_data.place.xfields.Instagram.value || place_public_data.place.xfields.Instagram.label}`" target="_blank" data-toggle="tooltip"
            data-original-title="Follow us on Instagram">
            <i class="fab fa-instagram"></i>
            <span class="nav-link-inner--text d-lg-none">Instagram</span>
          </b-nav-item>
           <b-nav-item
            link-classes="nav-link-icon"
            v-if="place_public_data.place != undefined && place_public_data.place.xfields.Github != undefined && (place_public_data.place.xfields.Github.value || place_public_data.place.xfields.Github.label) != ''"
            :href="`${place_public_data.place.xfields.Github.value || place_public_data.place.xfields.Github.label}`"
            target="_blank"
            data-toggle="tooltip"
            data-original-title="Star us on Github"
          >
            <i class="fab fa-github"></i>
            <span class="nav-link-inner--text d-lg-none">Github</span>
          </b-nav-item>
        </b-navbar-nav -->
      </template>
    </base-nav>

    <div class="main-content">
      <zoom-center-transition :duration="pageTransitionDuration" mode="out-in">
        <router-view></router-view>
      </zoom-center-transition>
    </div>

    <footer class="pt-0 pb-5" id="footer-main">
      <b-container>
        <b-row align-v="center" class="justify-content-xl-between">
          <b-col xl="6" v-show="false">
            <div class="copyright text-center text-xl-left text-muted">
              © {{ year }}
              <a href="https://janoo.com.br/" class="font-weight-bold ml-1" target="_blank">Janoo</a>
            </div>
          </b-col>
          <b-col xl="12" v-if="!hideFooter" class="col-xl-6">
            <b-nav class="nav-footer justify-content-center">

              <small class="text-center text-white text-lg-left">COPYRIGHT © 2024 - JANOO® - v{{ bcVersion }}
             <!--   <a href="https://janoo.com.br/" target="_blank">
                  janoo.com.br
                </a> -->
              </small>
            </b-nav>
          </b-col>
        </b-row>
      </b-container>
    </footer>
  </div>
</template>
<script>
import { BaseNav } from "@/components"
import { ZoomCenterTransition } from "vue2-transitions"
import nodeService from "@/services/nodejs/index"
import { publicLogoSource, readPublicXField } from "@/store/utils/placePublicData"

export default {
  components: {
    BaseNav,
    ZoomCenterTransition
  },
  props: {
    backgroundColor: {
      type: String,
      default: "black"
    }
  },
  data() {
    let version = `${process.env.VUE_APP_VERSION}`


    return {
      bcVersion: version,
      year: new Date().getFullYear(),
      showMenu: false,
      menuTransitionDuration: 250,
      pageTransitionDuration: 200,
      year: new Date().getFullYear(),
      bcClasses: 'abc',
      place_public_data: [],
      placeLogoUrl: null,
      placeLogoObjectUrl: null,
      pid: '',
      hideFooter: false,
    };
  },
  computed: {
    title() {
      return `${this.$route.name} Page`
    },
    socialAddresses() {
      return ['facebook', 'instagram', 'github'].filter((key) => {
        const value = readPublicXField(
          this.place_public_data,
          key,
          key.charAt(0).toUpperCase() + key.slice(1)
        )
        return value && String(value).trim()
      }).length
    }
  },
  methods: {
    toggleNavbar() {
      document.body.classList.toggle("nav-open")
      this.showMenu = !this.showMenu;
    },
    closeMenu() {
      if (undefined != this.$refs.baseNav) {
        this.$refs.baseNav.closeMenu()
      }
      document.body.classList.remove("nav-open")
      this.showMenu = false;
    },
    setBackgroundColor() {
      document.body.classList.add("bg-default")
    },
    removeBackgroundColor() {
      document.body.classList.remove("bg-default")
    },
    updateBackground() {
      if (!this.$route.meta.noBodyBackground) {
        this.setBackgroundColor()
      } else {
        this.removeBackgroundColor()
      }
    },
    clearPlaceLogo() {
      if (this.placeLogoObjectUrl) {
        URL.revokeObjectURL(this.placeLogoObjectUrl)
        this.placeLogoObjectUrl = null
      }
    },
    async loadPlaceLogo() {
      this.clearPlaceLogo()
      this.placeLogoUrl = null
      const resolved = publicLogoSource(this.place_public_data)
      if (!resolved || !resolved.src) return
      if (resolved.type === 'url') {
        this.placeLogoUrl = resolved.src
        return
      }
      try {
        const response = await nodeService.getFileByPath(resolved.src)
        const objectUrl = URL.createObjectURL(
          new Blob([response.data], { type: response.data.type })
        )
        this.placeLogoObjectUrl = objectUrl
        this.placeLogoUrl = objectUrl
      } catch (error) {
        console.warn('Não foi possível carregar o logotipo do gestor:', error)
      }
    },
    loadPublicData() {
      this.pid = (new URLSearchParams(window.location.search.slice(1))).get('pid')
      if (!this.pid) return
      nodeService.getPlacePublicData(this.pid).then((response) => {
        this.place_public_data = response.data
        this.loadPlaceLogo()
        this.$emit('place_public_data_loaded')
        sessionStorage.setItem('place_public_data', JSON.stringify(response.data))
      })
    }
  },
  created() {
    this.loadPublicData()
  },
  beforeDestroy() {
    this.clearPlaceLogo()
    this.removeBackgroundColor();
  },
  beforeRouteUpdate(to, from, next) {
    // Close the mobile menu first then transition to next page
    if (undefined != this.$refs.baseNav) {
      this.$refs.baseNav.closeMenu()
    }
    if (this.showMenu) {
      this.closeMenu()
      setTimeout(() => {
        next()
      }, this.menuTransitionDuration);
    } else {
      next()
    }
  },
  watch: {
    // $route: {
    //   immediate: true,
    //   handler: function() {
    //     this.updateBackground()
    //   }
    // }
  }
};
</script>
<style lang="scss">
$scaleSize: 0.8;

@keyframes zoomIn8 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }

  100% {
    opacity: 1;
  }
}

.main-content .zoomIn {
  animation-name: zoomIn8;
}

@keyframes zoomOut8 {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}

.main-content .zoomOut {
  animation-name: zoomOut8;
}
</style>


<style>
.loginpage {
  background-image: url(/img/chapadadiamantina-221-c.png);

  background-size: cover;
  position: absolute;
  height: 100vh;
  width: 100vw;
  left: 0px;
  right: 0px;
}
</style>
